import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import {
  Button,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Paper,
  Grid,
  Typography,
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

import RfsStyles from '../rfs.module.css';
import commonStyles from '../../common/common.module.css';
import MaterialTable from 'material-table';
import Zoom from '@material-ui/core/Zoom';
import { CurrentAwb, RfsAwbHistory, RfsAwbInfo } from '../../../models/OfflineRfs';
import moment from 'moment';

const styles = (theme: Theme) =>
  createStyles({
    rowContainer: {
      paddingLeft: 20,
      paddingRight: 20,
    },
    button: {
      width: '100%',
      height: '34px',
      textTransform: 'none',
    },
    materialIcon: {
      margin: '10px 3px 0',
      fontSize: 20,
      '&:hover': {
        cursor: 'pointer',
      },
    },
    partShipButton: {
      marginTop: "12px",
      padding: "4px 18px",
    },
    tblContainer: {
      marginTop: "20px",
    },
  });

interface TruckCompanyProps {
  classes: any;
  handleChange: (type: string, event: any) => void;
  modalOpen: boolean;
  handleClose: (type: string) => void;
  awbHistory: Array<RfsAwbHistory>;
  awbInfo: RfsAwbInfo;
  handleSave: Function;
}

const shipmentHistory = (props: TruckCompanyProps) => {
  const { classes } = props;

  return (
    <Dialog
      open={props.modalOpen}
      onClose={() => props.handleClose('history')}
      aria-labelledby='form-dialog-title'
      maxWidth={'sm'}
      fullWidth={true}
      TransitionComponent={Zoom}
      transitionDuration={500}
    >
      <DialogTitle id='form-dialog-title'>
        <div className={RfsStyles.dialogTitle}>
          <div>
            <Typography className={RfsStyles.name} variant="h6">
              Part Shipment History
            </Typography>
            <Typography variant="body2">
              {props.awbInfo.code + "-" + props.awbInfo.number}
            </Typography>
          </div>
          <IconButton
            aria-label='Close'
            className={RfsStyles.close}
            onClick={() => props.handleClose('history')}>
            <CloseIcon color='primary' />
          </IconButton>
        </div>
        <hr />
      </DialogTitle>
      <DialogContent>
        <Grid container className={ RfsStyles.shipHistGridContainer } spacing={2}>
          <Grid item sm={3} md className={ RfsStyles.shipHistGridItems }>
            <TextField
              id='origin'
              label='Origin'
              value={ props.awbInfo.org }
              onChange={(event) => props.handleChange('org', event)}
              variant='outlined'
              className={ commonStyles.customTextField }
              InputProps={{
                classes: {
                  notchedOutline: `${ commonStyles.notchedOutline } ${ commonStyles.noNotch }`,
                },
              }}
              InputLabelProps={{
                shrink: true,
                className: commonStyles.customLabelProp,
              }}
            />
          </Grid>
          <Grid item sm={3} md className={ RfsStyles.shipHistGridItems }>
            <TextField
              id='destination'
              label='Destination'
              value={ props.awbInfo.dst }
              onChange={(event) => props.handleChange('dst', event)}
              variant='outlined'
              className={ commonStyles.customTextField }
              InputProps={{
                classes: {
                  notchedOutline: `${ commonStyles.notchedOutline } ${ commonStyles.noNotch }`,
                },
              }}
              InputLabelProps={{
                shrink: true,
                className: commonStyles.customLabelProp,
              }}
            />
          </Grid>
          <Grid item sm={3} md className={ RfsStyles.shipHistGridItems }>
            <TextField
              id='pieces'
              label='Pieces'
              type="number"
              value={ props.awbInfo.pieces }
              onChange={(event) => props.handleChange('pieces', event)}
              variant="outlined"
              className={ commonStyles.customTextField }
              InputProps={{
                classes: {
                  notchedOutline: `${ commonStyles.notchedOutline } ${ commonStyles.noNotch }`,
                },
              }}
              InputLabelProps={{
                shrink: true,
                className: commonStyles.customLabelProp,
              }}
            />
          </Grid>
          <Grid item sm={3} md className={ RfsStyles.shipHistGridItems }>
            <TextField
              id='weight'
              label='Weight'
              type="number"
              value={ props.awbInfo.weight }
              onChange={(event) => props.handleChange('weight', event)}
              variant='outlined'
              className={ commonStyles.customTextField }
              InputProps={{
                classes: {
                  notchedOutline: `${ commonStyles.notchedOutline } ${ commonStyles.noNotch }`,
                },
              }}
              InputLabelProps={{
                shrink: true,
                className: commonStyles.customLabelProp,
              }}
            />
          </Grid>
          <Grid item xs>
            <Button
              color='primary'
              variant='contained'
              className={ classes.partShipButton }
              onClick={() => props.handleSave()}
              disabled={ !props.awbInfo.code || !props.awbInfo.number }
              disableRipple
              disableElevation
            >
              Save
            </Button>
          </Grid>
        </Grid>

        <div className= { `${ commonStyles.wrapper } ${ RfsStyles.tblWrapper } ${ classes.tblContainer }`}>
          <h3 className={ commonStyles.header }> Orders </h3>
          <MaterialTable
            components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}
            columns={[
              {
                title: 'Flight',
                field: '',
                render: (history: RfsAwbHistory) => {
                  return `${history.iata_code}${history.rfs_number}/${moment(history.schedule_date,"YYYYMMDD").format('DD-MMM-YYYY').toUpperCase()}`;
                },
              },
              {
                title: 'Pcs',
                field: 'pieces'
              },
              {
                title: 'Weight',
                field: 'weight',
              },
            ]}
            data={props.awbHistory}
            options={{
              paging: false,
              pageSize: 10,
              headerStyle: {
                backgroundColor: 'var(--tbl_head_bkg)',
                color: 'var(--tbl_head_color)',
                zIndex: 2,
              },
              showTitle: false,
              pageSizeOptions: [15, 20],
              toolbar: false,
              sorting: false,
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default withStyles(styles)(shipmentHistory);
